import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AppModule} from './app.module';

import {APIUrl} from './constants';
import {ImagesServiceUrl} from './constants';

@Injectable({
  providedIn: 'root'
})
export class B2BService {

  readonly APIUrl = APIUrl;
  readonly ImagesServiceUrl = ImagesServiceUrl;

  constructor(private http:HttpClient) { }

  GetB2BRelevantAgents(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Relevant/Agents', val)
  }

  SwitchGridProductOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Switch/Grid/Product/Offer', val)
  }

  GetIndustryProductByStockOverRequestedQuantity(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Industry/Product/By/StockOverRequested/Quantity', val)
  }

  GetIndustryProductCalculatedSideOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Industry/Product/Calculated/SideOffers', val)
  }

  GetIndustryProductCalculatedSideOffersWithCollateral(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Industry/Product/Calculated/SideOffers/With/Collateral', val)
  }

  GetIndustryProductsBulkBestOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Industry/Products/Bulk/Best/Offers', val)
  }

  SwitchGridResultProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Switch/Grid/Result/Product', val)
  }

  ChangeGridQuantityVersion2(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Change/Grid/Quantity/Version2', val)
  }

  SearchIndustryProductNameAndPartNumberParrallelB2BBrandsVersion2(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Product/Name/And/PartNumber/Parrallel/B2B/Brands/Version2', val)
  }

  AdjustOrderDeliveryPreference(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Adjust/Order/Delivery/Preference', val)
  }

  B2BRUTE(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/RUTE', val)
  }

  GetB2BUserTrackingGridLines(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/User/Tracking/Grid/Lines', val)
  }

  GetB2BUserTrackingGridsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/User/Tracking/Grids/Filtered', val)
  }

  GetB2BTrackingSearchCountsByPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Tracking/Search/Counts/By/Partner', val)
  }

  GetB2BTrackingSearchCountsByBrand(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Tracking/Search/Counts/By/Brand', val)
  }

  GetB2BTrackingSearchCountsTimeSeries(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Tracking/Search/Counts/Time/Series', val)
  }

  GetB2BTrackingValuesByPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Tracking/Values/By/Partner', val)
  }

  GetB2BTrackingValuesByBrand(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Tracking/Values/By/Brand', val)
  }

  GetB2BTrackingValuesTimeSeries(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Tracking/Values/Time/Series', val)
  }

  AddB2BTrackingScreenshot(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Add/B2B/Tracking/Screenshot', val)
  }

  GetB2BTrackingScreenshotsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Tracking/Screenshots/Filtered', val)
  }

  SearchIndustryProductB2BBrandsVersion2(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Product/B2B/Brands/Version2', val)
  }

  SwitchGridBrandVersion2(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Switch/Grid/Brand/Version2', val)
  }

  SearchIndustryProductB2BOffersVersion2(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Product/B2B/Offers/Version2', val)
  }

  SearchIndustryProductB2BOffersWithMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Product/B2B/Offers/With/MasterData', val)
  }

  // Retrieves a specific B2B offer by OfferID with master data
  GetIndustryProductB2BOfferWithMasterDataByOfferID(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Industry/Product/B2B/Offer/With/MasterData/By/OfferID', val)
  }

  SearchIndustryProductB2BOffersExactMatch(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Product/B2B/Offers/ExactMatch', val)
  }

  SearchIndustryProductB2BOffersExactMatchWithMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Product/B2B/Offers/ExactMatch/With/MasterData', val)
  }

  // Combined search: calls FTS and ExactMatch in parallel when search term is short (< 5 chars after normalization)
  SearchIndustryProductB2BOffersVersion2Combined(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Product/B2B/Offers/Version2/Combined', val)
  }

  // Combined search with master data: calls FTS and ExactMatch in parallel when search term is short
  SearchIndustryProductB2BOffersWithMasterDataCombined(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Product/B2B/Offers/With/MasterData/Combined', val)
  }

  BulkSearchIndustryProductB2BOffersWithMasterData(val:any):Observable<any>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Bulk/Search/Industry/Product/B2B/Offers/With/MasterData', val)
  }

  BulkSearchIndustryProductB2BOffersVersion2(val:any):Observable<any>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Bulk/Search/Industry/Product/B2B/Offers/Version2', val)
  }

  GetB2BUserConnectedPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/User/Connected/Partner', val)
  }

  IdentifyPartnerByVAT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Identify/Partner/By/VAT', val)
  }

  AddUpdateB2BUserPartnerConnection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Add/Update/B2B/User/Partner/Connection', val)
  }

  AddUpdateB2BUserAgentConnection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Add/Update/B2B/User/Agent/Connection', val)
  }

  DeallocateB2BUserAgentConnection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Deallocate/B2BUser/Agent/Connection', val)
  }

  GetB2BUserConnectedAgent(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/User/Connected/Agent', val)
  }

  GetGridCellItemDataWithDBLevelCalculation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Grid/Cell/Item/Data/With/DBLevel/Calculation', val)
  }

  GetGridCellItemData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Grid/Cell/Item/Data', val)
  }

  GetB2BMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Master/Data', val)
  }

  InitializeCartItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Initialize/Cart/Item', val)
  }

  ExchangeCartItemsPurchaseCurrency(val:any):Observable<any>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Exchange/Cart/Items/Purchase/Currency', val)
  }

  AddPartnerShippingAddressChangeRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Add/Partner/Shipping/Address/Change/Request', val)
  }

   GetPartnerShippingAddressChangeRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Partner/Shipping/Address/Change/Request', val)
  }

  GetPartnerLastB2BPaymentShipmentSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Partner/Last/B2B/Payment/Shipment/Settings', val)
  }

  AdminEditGridCell(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Admin/Edit/Grid/Cell', val)
  }

  AdminGridCurrencyRowsChange(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Admin/Grid/Currency/Rows/Change', val)
  }

  SaveAdminQuotationProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Save/Admin/Quotation/Product', val)
  }

  BulkSaveAdminQuotationProducts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Bulk/Save/Admin/Quotation/Products', val)
  }

  GetOrderConfirmationsTransitItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/OrderConfirmations/Transit/Items', val)
  }

  GetOrderConfirmationsTransitItemsWithPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/OrderConfirmations/Transit/Items/WithPartner', val)
  }

  AddUpdateOrderConfirmationTransitItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Add/Update/OrderConfirmation/Transit/Item', val)
  }

  DeleteOrderConfirmationTransitItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Delete/OrderConfirmation/Transit/Item', val)
  }

  InitializeCart(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Initialize/Cart', val)
  }

  ProofUserB2BData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Proof/User/B2B/Data', val)
  }

  PopulateCartItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Populate/Cart/Items', val)
  }

  ChangeGridCellItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Change/Grid/Cell/Item', val)
  }

  ExportB2BGrid(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Export/B2B/Grid', val)
  }

  SearchIndustryProductsFromGridCell(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Products/From/Grid/Cell', val)
  }

  SplitGetIndustryProductsSearchQuery(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Split/Get/Industry/Products/Search/Query', val)
  }

  GetB2BInvoices(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Invoices', val)
  }

  GetInvoicesFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Invoices/COUNT', val)
  }

  GetAggregatedOverdueInvoices(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Aggregated/Overdue/Invoices', val)
  }

  GetOrdersMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Orders/Get/Orders/Master/Data', val)
  }

  GetProductLeadTime(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Orders/Get/Product/Lead/Time', val)
  }

  ChangeOfferStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Change/Offer/Request/Status', val)
  }

  AddNewOfferRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Add/New/Offer/Request', val)
  }

  GetOfferLastSelectedAgentsAndAddressByPartnerID(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request/Last/Selected/Agents/And/Address/By/PartnerID', val)
  }

  DownloadOfficialOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Download/Official/OfferPDF', val)
  }

  GetOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request', val)
  }

  GetOfferLogs(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request/Logs', val)
  }

  GetOfferItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request/Items', val)
  }

  GetOfferMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request/Master/Data', val)
  }

  GetOffersFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Requests/Filtered', val)
  }

  GetOffersFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Requests/Filtered/COUNT', val)
  }

  // B2B My Offers page - uses Offers API instead of OfferRequests
  GetB2BOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/Offer', val)
  }

  GetB2BOfferMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/Offer/Master/Data', val)
  }

  GetB2BOffersFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/Offers/Filtered', val)
  }

  GetB2BOffersFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/Offers/Filtered/COUNT', val)
  }

  CancelOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Cancel/Offer/Request', val)
  }

  ExportOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Export/Offer/Request', val)
  }

  // ByPartner - partner-scoped versions for B2B portal security
  GetOfferByPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request/ByPartner', val)
  }

  ExportOfferByPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Export/Offer/Request/ByPartner', val)
  }

  CancelOfferByPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Cancel/Offer/Request/ByPartner', val)
  }

  GetClientOCDetailsByPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Client/OC/Details/ByPartner', val)
  }

  AcceptNewlyQuotedPricesOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Accept/Newly/Quoted/Prices', val)
  }

  PreCheckOfferConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Pre/Check/Offer/Request/Confirmation', val)
  }

  UpdateOfferShippingAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Update/Offer/Request/Shipping/Address', val)
  }

  GetSupplierClientOpenBoxes(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Supplier/Client/Open/Boxes', val)
  }

  GetB2BHomePageMessage(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Home/Page/Message', val)
  }

  GetUserManagerUnreadOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/User/Manager/Unread/Offer/Requests', val)
  }

  GetB2BPartnerRelatedCompanies(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Partner/Related/Companies', val)
  }
  
  GetB2BListedBrands(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Listed/Brands', val)
  }

  GetB2BClientOrders(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Client/Orders', val)
  }

  GetClientOCDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Client/OC/Details', val)
  }

  GetB2BUserClients(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/User/Clients', val)
  }

  PrepareGridCellItemSideOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Prepare/Grid/Cell/Item/Side/Offers', val)
  }

  GetB2BClientOCReadyItemsUX(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Client/OCReady/Items', val)
  }

  SendDispatchEmailClientRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Send/Dispatch/Email/Client/Request', val)
  }

  CheckExceedingStocks(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Check/Exceeding/Stocks', val)
  }

  SendClientRequestToPendingOrderConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Send/Client/Request/To/Pending/Order/Confirmation', val)
  }

  AddNewClaim(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Add/New/Claim', val)
  }

  UpsertClaimProducts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Upsert/Claim/Products', val)
  }

  GetMyClaimsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/My/Claims/Filtered', val)
  }

  GetClaimByID(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Claim/By/ID', val)
  }

  AddClaimComment(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Add/Claim/Comment', val)
  }

  AddClaimCommentReply(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Add/Claim/Comment/Reply', val)
  }

  GetInvoiceProductsForClaim(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Invoice/Products/For/Claim', val)
  }

  GetReceptionProductsForClaim(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Reception/Products/For/Claim', val)
  }

  // Solution Management Methods
  AddUpdateProductSolution(val: any): Observable<any> {
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Add/Update/Product/Solution', val);
  }

  GetProductSolution(val: any): Observable<any> {
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Product/Solution', val);
  }

  UpdateClaimStatus(val: any): Observable<any> {
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Update/Claim/Status', val);
  }

  // Search receptions by product name/code for claims (External claims) - uses FTS stored procedure
  SearchReceptionsByProductFTS(val: any): Observable<any[]> {
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Search/Receptions/ByProduct/FTS', val);
  }

  // Claim Partner Agents Methods
  AddClaimPartnerAgent(val: any): Observable<any> {
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Add/Claim/Partner/Agent', val);
  }

  GetClaimPartnerAgents(val: any): Observable<any> {
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Claim/Partner/Agents', val);
  }

  DeleteClaimPartnerAgent(val: any): Observable<any> {
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Delete/Claim/Partner/Agent', val);
  }

  GetB2BUserNotifications(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/User/Notifications', val)
  }

  UpdateB2BUserNotification(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Update/B2B/User/Notification', val)
  }

  // Retrieves the B2B User ID connected to a specific Partner (reverse of GetB2BUserConnectedPartner)
  GetPartnerB2BUserConnection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Partner/B2B/User/Connection', val)
  }

  GetPartnerAggregatedFinancialData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Partner/Aggregated/Financial/Data', val)
  }

  /**
   * Checks partner's blocking status based on overdue invoices.
   * Returns the oldest overdue invoice data and partner's unpaid tolerance days.
   *
   * Backend query criteria:
   * - FK_PartnerID = @PartnerID
   * - FK_CompanyID = @CompanyID (company-specific, same partner can have different status per company)
   * - DocumentStatus != 1 (not collected)
   * - ForceDocumentClosing != 1 (not force-closed, as these are treated as settled)
   * - PaymentDueDate < GETDATE() (overdue)
   *
   * The frontend calculates if the partner should be blocked based on:
   * - Finding oldest overdue invoice days
   * - Comparing against partner's UnpaidToleranceDays threshold
   */
  GetPartnerInvoiceBlockingStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Partner/Invoice/Blocking/Status', val)
  }

  /**
   * Exports a B2B overdue invoice as PDF.
   * This endpoint patches the user context based on the invoice's company
   * before delegating to InvoicingBL.ExportInvoice.
   *
   * Request: { User, Language, Invoice (full object with Company) }
   * Response: { Status, Message, Document: { Name, PDFStream, ID } }
   */
  ExportB2BOverdueInvoice(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Export/B2B/Overdue/Invoice', val)
  }
}
